import React from 'react';
import ComparisonSurface from './ComparisonSurface';
import ComparisonCanvas from './ComparisonCanvas';

/**
 * Renderiza el bloque ComparisonView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function ComparisonView({
  v
}) {
  const dayPickerRef = React.useRef(null);
  const dayPicker = v.cDayPicker;
  React.useEffect(() => {
    if (!v.viewCmp || !dayPicker?.open) return undefined;
    const closeOnOutsideClick = event => {
      if (!dayPickerRef.current?.contains(event.target)) dayPicker.close();
    };
    const closeOnEscape = event => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        dayPicker.close();
      }
    };
    document.addEventListener('pointerdown', closeOnOutsideClick);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnOutsideClick);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [v.viewCmp, dayPicker]);
  return v.viewCmp ? React.createElement(React.Fragment, null, v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": "18.75vw minmax(0,1fr)",
      "gap": "1.111111vh"
    }
  }, v.text("\n    "), React.createElement("aside", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.296296vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.481481vh",
      "minHeight": "0"
    }
  }, v.text("\n      "), React.createElement("button", {
    "onClick": v.backDet,
    style: {
      "alignSelf": "flex-start",
      "background": "#16213a",
      "border": "0.092593vh solid oklch(0.78 0.12 250)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text("‹ Volver a General")), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, v.text("\n        "), React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.388889vh",
      "fontWeight": "600"
    }
  }, v.text("Comparar días · " + v.selName)), v.text("\n        "), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text("Cambia la jaula con ‹ › arriba")), v.text("\n      ")), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh"
    }
  }, v.text("\n        "), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text(v.cMetricTitle)), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "1fr 1fr",
      "gap": "0.37037vh"
    }
  }, [...(v.cMetricMain || []), ...(v.cMetricMore ? v.cMetricExtra || [] : [])].map((m, index152) => React.createElement(React.Fragment, {
    key: index152
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "padding": "0.555556vh 0.925926vh",
      "borderRadius": "0.555556vh",
      "cursor": "pointer",
      "font": "1.203704vh 'IBM Plex Sans',sans-serif",
      "textAlign": "left",
      "border": "0.092593vh solid " + m.bd,
      "background": m.bg,
      "color": m.color
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "background": m.dot
    }
  }, null), v.text(m.label))))), React.createElement("button", {
    "onClick": v.cMetricToggle,
    style: {
      "alignSelf": "flex-start",
      "border": "0",
      "background": "transparent",
      "color": "#8da2bd",
      "padding": "0.185185vh 0",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text(v.cMetricMore ? "− Menos métricas" : "+ Más métricas")), v.text("\n      ")), v.text("\n      \n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text("Días"))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.555556vh"
    }
  }, (v.cSelectedDays || []).map((day, index153) => React.createElement("button", {
    key: index153,
    "type": "button",
    "onClick": day.onRemove,
    "title": day.canRemove ? "Quitar de la comparación" : "Debe quedar al menos un día",
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "minHeight": "2.777778vh",
      "padding": "0.37037vh 0.740741vh",
      "borderRadius": "0.555556vh",
      "border": "0.092593vh solid " + day.color,
      "background": "rgba(255,255,255,0.035)",
      "color": "#e4e9f0",
      "cursor": day.canRemove ? "pointer" : "default",
      "font": "1.018519vh 'IBM Plex Mono',monospace"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.364583vw",
      "height": "0.648148vh",
      "borderRadius": "50%",
      "background": day.color
    }
  }), v.text(day.lab), React.createElement("span", {
    style: {
      "color": "#8793a6",
      "fontSize": "1.203704vh"
    }
  }, v.text(day.canRemove ? "×" : ""))))), React.createElement("div", {
    ref: dayPickerRef,
    style: {
      "position": "relative",
      "width": "100%"
    }
  }, React.createElement("button", {
    "type": "button",
    "onClick": v.cDayPicker.toggle,
    "aria-haspopup": "listbox",
    "aria-expanded": v.cDayPicker.open,
    "title": "Selecciona varios días para comparar",
    style: {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-start",
      "gap": "0.092593vh",
      "width": "100%",
      "minHeight": "4.259259vh",
      "boxSizing": "border-box",
      "padding": "0.277778vh 2.407407vh 0.277778vh 0.925926vh",
      "position": "relative",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid " + v.cDayPicker.bd,
      "borderRadius": "0.648148vh",
      "cursor": "pointer",
      "color": "#e4e9f0",
      "textAlign": "left"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#8793a6",
      "lineHeight": "1.1"
    }
  }, v.text("Días seleccionados")), React.createElement("span", {
    style: {
      "font": "700 1.296296vh 'IBM Plex Mono',monospace",
      "lineHeight": "1.2",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.cDayPicker.value)), React.createElement("span", {
    "aria-hidden": "true",
    style: {
      "position": "absolute",
      "right": "0.416667vw",
      "top": "50%",
      "transform": "translateY(-50%)",
      "fontSize": "0.925926vh",
      "color": "oklch(0.66 0.19 42)"
    }
  }, v.text("▾"))), v.cDayPicker.open ? React.createElement("div", {
    "role": "listbox",
    "aria-label": "Días para comparar",
    "aria-multiselectable": "true",
    "onWheel": v.stopProp,
    style: {
      "position": "absolute",
      "top": "calc(100% + 0.37037vh)",
      "left": "0",
      "right": "0",
      "zIndex": "70",
      "maxHeight": "27.777778vh",
      "overflowY": "auto",
      "background": "#101c2e",
      "border": "0.092593vh solid rgba(184,193,206,0.18)",
      "borderRadius": "0.740741vh",
      "boxShadow": "0 1.296296vh 3.148148vh rgba(0,0,0,0.55)",
      "padding": "0.37037vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "overscrollBehavior": "contain"
    }
  }, (v.cDayOptions || []).map((option, optionIndex) => React.createElement("button", {
    key: optionIndex,
    "type": "button",
    "role": "option",
    "aria-selected": option.selected,
    "disabled": option.disabled,
    "onClick": option.onClick,
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "center",
      "gap": "1.111111vh",
      "padding": "0.555556vh 0.925926vh",
      "border": "0",
      "borderRadius": "0.462963vh",
      "background": option.bg,
      "color": option.color,
      "cursor": option.disabled ? "not-allowed" : "pointer",
      "opacity": option.disabled ? "0.45" : "1",
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "whiteSpace": "nowrap",
      "textAlign": "left",
      "flex": "none"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {}, v.text(option.lab)), React.createElement("span", {
    style: {
      "font": "700 1.111111vh 'IBM Plex Sans',sans-serif",
      "color": option.selected ? "oklch(0.8 0.14 60)" : "#8793a6"
    }
  }, v.text(option.mark))))) : null), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.37037vh",
      "flexWrap": "wrap"
    }
  }, (v.cDayPresets || []).map((preset, presetIndex) => React.createElement("button", {
    key: presetIndex,
    "type": "button",
    "onClick": preset.onClick,
    style: {
      "border": "0.092593vh solid #26344a",
      "background": "#151f30",
      "color": "#9da9ba",
      "borderRadius": "0.462963vh",
      "padding": "0.37037vh 0.648148vh",
      "cursor": "pointer",
      "font": "1.018519vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text(preset.label))))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "flexWrap": "wrap"
    }
  }, v.text("\n          "), React.createElement("span", {}, v.text("Color = alarmas del día")), v.text("\n          "), React.createElement("span", {
    style: {
      "display": "flex",
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "#151d2b"
    }
  }, null), React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.42 0.1 25)"
    }
  }, null), React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.54 0.14 25)"
    }
  }, null), React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "oklch(0.65 0.18 25)"
    }
  }, null)), v.text("\n          "), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.37037vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "repeating-linear-gradient(135deg,#2a3446 0 0.277778vh,#0f1623 0.277778vh 0.555556vh)"
    }
  }, null), v.text("ayuno")), v.text("\n        ")), v.text("\n      ")), v.text("\n    ")), v.text("\n    "), React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.296296vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh",
      "minHeight": "0",
      "minWidth": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "center",
      "gap": "1.111111vh"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "1.111111vh",
      "minWidth": "0"
    }
  }, v.text("\n          "), v.cNotSup ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "alignItems": "center",
      "gap": "0.555556vh 1.481481vh",
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text("\n            "), (v.cMLeg || []).map((l, index154) => React.createElement(React.Fragment, {
    key: index154
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.729167vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": l.c
    }
  }, null), React.createElement("span", {
    style: {
      "color": "#e4e9f0",
      "fontWeight": "500"
    }
  }, v.text(l.lab)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text(l.range))))), v.text("\n            "), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#5a667a",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.cDaysN)), v.text("\n          "))) : null, v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.740741vh",
      "flex": "none"
    }
  }, v.text("\n          \n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.cModes || []).map((m, index155) => React.createElement(React.Fragment, {
    key: index155
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 1.111111vh",
      "font": "1.203704vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw
    }
  }, v.text(m.label))))), v.text("\n        ")), v.text("\n      ")), v.text("\n      "), React.createElement(ComparisonSurface, {
    v
  }), v.text("\n      "), React.createElement(ComparisonCanvas, {
    v
  }), v.text("\n    ")), v.text("\n  ")), v.text("\n  ")) : null;
}
